import {
  DELIVERY,
  LEVEL_VALUES,
  PARTICIPANTS_EXCLUDE_FILTER_VALUES,
  SEND_REMINDER_EVERY_X_BUSINESS_DAYS_VALUES,
} from 'containers/AwarenessCenter/constants'

const typeKey = 'AwarenessCenter/WizardSpearPhishingCampaign'

export const CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA = `${typeKey}/CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA`
export const CHANGE_IS_FAILED_GENERATED_EMAILS_MODAL_OPEN = `${typeKey}/CHANGE_IS_FAILED_GENERATED_EMAILS_MODAL_OPEN`

export const DEFAULT_SPEAR_PHISHING_PROPERTIES = {
  sendAllWeek: true,
  sendReminderEveryXBusinessDays: SEND_REMINDER_EVERY_X_BUSINESS_DAYS_VALUES.CHECKED,
  sendCampaignSummaryToCampaignReportRecipients: true,
  sendCampaignFailedEmail: false,
}

export const DEFAULT_SPEAR_PHISHING_CAMPAIGN_OBJECT = {
  // id: null,
  participants: {
    page: 1,
    selectorLoader: false,
    modalLoader: false,
    error: null,
    modalSearch: '',
    excludeFilter: PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED,
    included: {},
    excluded: {},
    items: [],
    meta: {
      awarenessLevels: {
        [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
        [LEVEL_VALUES.MID_LEVEL]: 0,
        [LEVEL_VALUES.EXPERT_LEVEL]: 0,
      },
      count: 0,
    },
    includedSelectionIds: [],
    excludedSelectionIds: [],
  },
  ...DEFAULT_SPEAR_PHISHING_PROPERTIES,
  delivery: DELIVERY.EMAIL,
  selectedLandingPage: {},
  selectedTrainingVideo: [],
  // NOTE: getSimulationCampaignLaunchProperties() changed to null if form of active period is not valid
  sendingDays: null,
  spearPhishingCampaignData: {},
  generatedEmailsParticipants: [],
  generatedEmailsParticipantsLoader: false,
  notifications: [],
}

export const LIMIT_PARTICIPANTS_SPEAR_PHISHING = 2000
